import { Container, Navbar, Row, Col } from "react-bootstrap";
import "./footer.css";
import packageJson from "../../../package.json";

const currentYear = new Date().getFullYear(); // Obtiene el año actual


function Footer() {
  return (
    <div className="footer-container p-0 m-0">
      <div className="linea-amarilla"></div>
      <Navbar className="fondo-texto primera-linea-footer m-0 p-0" style={{ height: '64px' }}>
        <Container fluid className="p-0 m-0 ">
          <Row className="m-0 p-0 w-100 d-flex flex-wrap primera-linea-footer">
            <Col xs={12} className="p-0 m-0 flex-wrap justify-content-start text-center d-flex ">
              <Navbar.Brand            
                className="primera-linea-footer mx-0 px-2 my-2 mx-sm-5 px-sm-3" 
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                BOPIWEB - {packageJson.version}
              </Navbar.Brand>
            </Col>
          </Row>        
        </Container>
      </Navbar>
      <Navbar style={{height: "1px", padding: "0", backgroundColor: "#ffffff"}}></Navbar>
      <Navbar className="navbar-oscuro  d-flex flex-wrap w-100 m-0 p-0">
        <Container fluid className="d-flex flex-wrap  m-0 p-0">
          <Row className="m-0 p-0 w-100 d-flex flex-wrap fondo-texto pt-3"  style={{ minHeight: '82px' }}>
            <Col md={12} lg={5}  className="m-0 p-0 flex-wrap justify-content-start d-flex ">
              <Navbar.Brand 
                // href="#home" 
                className="fondo-texto  mx-0 px-2 my-2 mx-sm-5 px-sm-3" 
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                © Oficina Española de Patentes y Marcas, {currentYear} {/* Muestra el año actual */}
              </Navbar.Brand>
            </Col>
            <Col md={12} lg={6} className="p-0 fondo-texto pt-3 d-flex text-lg-end justify-content-lg-end">
            <div className="m-0 p-0 d-flex justify-content-lg-end flex-wrap gap-2" >
              <Navbar.Brand
                href="https://www.oepm.es/es/accesibilidad/"
                className="m-0 p-0 fondo-texto mx-2 my-0"
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                Accesibilidad
              </Navbar.Brand>
              <Navbar.Brand
                href="https://www.oepm.es/es/avisos-legales/"
                className="m-0 p-0 fondo-texto mx-2 my-0"
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                Aviso Legal
              </Navbar.Brand>
              <Navbar.Brand
                href="https://www.oepm.es/es/politica-de-cookies/"
                className="p-0 fondo-texto mx-2 my-0"
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                Política de Cookies
              </Navbar.Brand>
              <Navbar.Brand
                href="https://www.oepm.es/es/proteccion-de-datos/"
                className="p-0 fondo-texto mx-2 my-0"
                style={{whiteSpace: "normal", wordWrap: "break-word"}}
              >
                Protección de datos
              </Navbar.Brand>
              </div>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </div>
  );
}

export default Footer;
